import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const { t } = useT();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError(t("auth.pw_mismatch"));
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: pw });
      await refresh();
      toast.success(t("auth.reset_done"));
      nav(data.role === "provider" ? "/provider" : ["admin", "support", "finance"].includes(data.role) ? "/admin" : "/search");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-container py-10 max-w-lg">
      <form onSubmit={submit} className="w-card p-6 md:p-8 space-y-4 w-rise" data-testid="reset-form">
        <h1 className="text-3xl font-extrabold">{t("auth.reset_title")}</h1>
        {!token && <p role="alert" className="font-semibold text-[var(--w-error)]" data-testid="reset-no-token">{t("auth.reset_invalid")}</p>}
        <label className="block"><span className="w-label">{t("auth.new_password")}</span>
          <input className="w-input" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" data-testid="reset-password-input" />
          <span className="w-muted text-sm">{t("auth.pw_hint")}</span></label>
        <label className="block"><span className="w-label">{t("auth.repeat_password")}</span>
          <input className="w-input" type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" data-testid="reset-password2-input" /></label>
        {error && <p role="alert" className="font-semibold text-[var(--w-error)]" data-testid="reset-error">{error}</p>}
        <button className="w-btn w-btn-primary w-full" disabled={busy || !token} data-testid="reset-submit-btn">{busy ? t("common.loading") : t("auth.reset_submit")}</button>
        <p className="text-center"><Link to="/auth" className="font-semibold underline text-mint-ink" data-testid="reset-back-login">{t("auth.back_login")}</Link></p>
      </form>
    </div>
  );
}
